import {
  showModal,
  MODAL_CLIENT_SELECT_USER,
  MODAL_NETWORK_OFF,
  MODAL_SERVER_DOWN
} from 'redux/modules/modals'
import moment from 'moment'
export const UserSelectionMiddleware = store => next => action => {
  if (__DEV__) console.log('dispatching', action)
  let result = next(action)
  const { users, modals } = store.getState()
  if (
    (modals.currentModal && modals.currentModal.includes('ADMIN')) ||
    modals.currentModal === MODAL_NETWORK_OFF ||
    modals.currentModal === MODAL_SERVER_DOWN ||
    modals.currentModal === MODAL_CLIENT_SELECT_USER
  ) {
    return result
  }
  if (users.list.length !== 0 && users.currentUser === null) {
    store.dispatch(showModal(MODAL_CLIENT_SELECT_USER))
    return result
  }
  if (
    users.currentUser &&
    users.currentUser.auth &&
    users.currentUser.expiresAt
  ) {
    if (moment(users.currentUser.expiresAt).isBefore(moment())) {
      store.dispatch(showModal(MODAL_CLIENT_SELECT_USER))
    }
  }
  if (__DEV__) console.log('next state', store.getState())
  return result
}

export const logoutMiddleware = store => next => action => {
  if (action.type === 'SIGN_OUT_SUCCESS' && action.onReset) {
    action.onReset()
    return next(action)
  }
  return next(action)
}
export const timeMiddleware = store => next => action => {
  // console.log(time)
  // console.log('Local clock is off by: ' + time.t + ' milliseconds')
  return next(action)
}
export const snackBarMiddleware = store => next => action => {
  if (__DEV__) console.log('dispatching', action)
}



// WEBPACK FOOTER //
// ./src/store/middlewares.js